<template>
  <div style="letter-spacing:0.2em;">
    <TopBar pagetitle="绑定My SSI账号" :back-url="url" />
    <div :model="dataForm" class="whiteForm">
      <van-row class="noticeH1">
        仅需一步，绑定成功！
      </van-row>
      <van-row class="noticeH2">
        你将享受以下权益
      </van-row>
      <van-row class="noticeH3">
        随时在线学习课程内容<br>
        快速查询身边潜水中心<br>
        便捷获取最新潜水信息<br>
      </van-row>
      <div class="van-hairline--top linesizeSmall" />
      <van-row>
        <van-col span="6">姓<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.lastname" placeholder="请输入英文姓(拼音)">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">名<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.firstname" placeholder="请输入英文名(拼音)">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">生日<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.birthday" placeholder="请输入生日" readonly @click="showDateSelect=true">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">邮箱<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.email" placeholder="请输入电子邮箱">
        </van-col>
      </van-row>
      <van-button type="info" size="large" :loading="bindSSILoading" loading-text="绑定中..." @click="bindSSI">绑定</van-button>

      <van-popup v-model="showDateSelect" position="bottom">
        <van-datetime-picker
          v-model="birthday1"
          type="date"
          :max-date="maxDate"
          :min-date="minDate"
          :formatter="formatter"
          @confirm="onDateConfirm"
          @cancel="onDateCancel"
        />
      </van-popup>

      <van-popup v-model="showDiveCenterSelect" position="bottom">
        <van-picker
          ref="DiveCenterSelect"
          :visible-item-count="10"
          :loading="DiveCenterSelectLoading"
          title="选择心仪的潜水中心"
          show-toolbar
          :columns="columnsDiveCenter"
          @change="onChangeDiveCenter"
          @cancel="onDiveCenterCancel"
          @confirm="onDiveCenterConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { initPage, getUrlKey, formatDate, MyNotify } from '@/utils/base'
import { Field, Button, Checkbox, DatetimePicker, Popup, Dialog, Picker } from 'vant'
import TopBar from '@/components/TopBar'
// const diveCenters = {
//   '四川': [{ text: '酷潜潜水中心', value: '111111' }, { text: '测试中心', value: '222222' }],
//   '广州': [{ text: '汉森潜水中心', value: '111111' }]
// }
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Picker.name]: Picker,
    TopBar
  },
  data() {
    return {
      url: undefined,
      bindOkUrl: undefined,
      showDateSelect: false,
      bindSSILoading: false,
      DiveCenterSelectLoading: true,
      showDiveCenterSelect: false,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      birthday1: new Date(1990, 6, 15),
      diveCenters: undefined,
      dataForm: {
        // lastname: 'chen',
        // firstname: 'shiqian',
        // birthday: '',
        // email: '172298479a@qq.com',
        lastname: '',
        firstname: '',
        birthday: '',
        email: '',
        trueBind: false,
        divecenterId: undefined,
        isInDiveCenter: false
      },
      columnsDiveCenter: undefined
    }
  },
  activated() {
    this.minDate = new Date(1900, 1, 1)
  },
  created() {
    initPage(false)
    this.url = getUrlKey('url')
    this.bindOkUrl = this.url
    this.url = '/home/index'
    // if (this.url === '/textbook/index') {
    //   this.url = '/home/index'
    // } else if (this.url === '/textbook/license') {
    //   this.url = '/users/index'
    // }
    request({
      url: '/user/getUserBirthday',
      method: 'get'
    }).then(Response => {
      this.isInDiveCenter = Response.data.isInDc
      var dt = new Date(Response.data.birthday)
      if (!dt || dt.getFullYear() < 1900) {
        return
      }
      this.birthday1 = dt
      this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
    })
  },
  methods: {
    bindSSI() {
      if (this.dataForm.lastname.trim().length < 1) {
        MyNotify('info', '请输入英文姓(拼音)')
        return
      }
      if (this.dataForm.firstname.trim().length < 1) {
        MyNotify('info', '请输入英文名(拼音)')
        return
      }
      if (this.dataForm.email.trim().length < 5) {
        MyNotify('info', '请输入邮箱')
        return
      }
      // var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      // if (!myreg.test(this.dataForm.email.trim())) {
      //   MyNotify('info', '请输入正确的邮箱')
      //   return
      // }

      if (!this.dataForm.birthday || this.dataForm.birthday.trim().length < 10) {
        MyNotify('info', '请输入生日')
        return
      }
      var postdata = JSON.parse(JSON.stringify(this.dataForm))
      this.bindSSILoading = true
      request({
        url: '/user/bindSSIAccount',
        method: 'post',
        data: postdata
      }).then(Response => {
        this.bindSSILoading = false
        switch (Response.data.type) {
          case 'BIND_SUCCESS':
            MyNotify('success', '绑定成功!')
            if (this.url) {
              this.$router.replace(this.bindOkUrl)
            } else {
              this.$router.replace('/')
            }
            break
          case 'NEED_REG':
            Dialog.confirm({
              title: '没有找到匹配的My SSI账号',
              message: '请仔细检查姓名、生日是否输入正确。\r\n返回检查或者新注册一个My SSI账号并绑定',
              cancelButtonText: '注册',
              confirmButtonText: '检查'
            }).then(() => {
              // 检查 无操作
            }).catch(() => {
              // 如果已经有归属潜水中心，则不需要在让用户选择
              if (this.isInDiveCenter) {
                this.bindSSI()
              }
              // 注册
              this.showDiveCenterSelect = true
              request({
                url: '/user/getDiveCenterList',
                method: 'get'
              }).then(Response => {
                this.DiveCenterSelectLoading = false
                this.diveCenters = Response.data.data
                this.columnsDiveCenter = [
                  {
                    values: Object.keys(this.diveCenters),
                    className: 'column1'
                  },
                  {
                    values: this.diveCenters[Response.data.select],
                    className: 'column2',
                    defaultIndex: 2
                  }
                ]
              })
              // Dialog.alert({
              //   title: '请选择一个潜水中心',
              //   message: '稍后请选择一个心仪的潜水中心，完成注册!'
              // }).then(() => {

              // })
            })
            break
          case 'NEED_REG_CHANGE_EMAIL':
            Dialog.alert({
              title: '邮箱已被占用',
              message: '没有找到与My SSI匹配的账号,并且该邮箱已经被注册,请仔细检查姓名、生日是否输入正确。或者切换一个邮箱注册My SSI账号!'
            })
            break
          case 'ACCOUNT_IS_BIND':
            Dialog.confirm({
              title: 'My SSI账号已被绑定',
              message: '该账号已经被' + Response.data.phone + '绑定,是否要覆盖绑定?\r\n(一旦绑定后其他用户将会被解除绑定)',
              cancelButtonText: '覆盖绑定',
              confirmButtonText: '取消'
            }).then(() => {
              // 取消 无操作
            }).catch(() => {
              // 覆盖绑定
              this.dataForm.trueBind = true
              this.bindSSI()
              this.dataForm.trueBind = false
            })
            break
        }
      })
    },
    onDateConfirm() {
      this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    onDateCancel() {
      this.showDateSelect = false
      this.dataForm.birthday = undefined
    },
    formatDate,
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    onChangeDiveCenter(picker, values) {
      picker.setColumnValues(1, this.diveCenters[values[0]])
    },
    onDiveCenterCancel() {
      this.showDiveCenterSelect = false
    },
    onDiveCenterConfirm() {
      this.showDiveCenterSelect = false
      var selectDc = this.$refs.DiveCenterSelect.getValues()
      if (selectDc.length !== 2 || !selectDc[1].value) {
        MyNotify('info', '未选择潜水中心')
        return
      }
      this.dataForm.divecenterId = selectDc[1].value
      this.bindSSI()
      this.dataForm.divecenterId = undefined
    }
  }

}
</script>

<style scoped>
.linesizeSmall{
  padding: .6em 0;
}
</style>
